/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ISocialPostListItem } from '../social-post-schema';
import { socialPostListItemSchema } from '../social-post-schema';

const postAttemptSchema = z.object({
  id: z.number(),
  attemptNumber: z.number(),
  stage: z.string(),
  success: z.boolean(),
  httpStatus: z.number().nullable(),
  providerCode: z.string().nullable(),
  message: z.string().nullable(),
  raw: z.string().nullable(),
  createdAt: z.number(),
});

export type ISocialPostAttempt = z.infer<typeof postAttemptSchema>;

const detailDataSchema = z.object({
  post: socialPostListItemSchema,
  attempts: z.array(postAttemptSchema),
});

export interface IGetSocialPostDetailV1Data {
  post: ISocialPostListItem;
  attempts: ISocialPostAttempt[];
}

export const getSocialPostDetailV1ResponseSchema = createApiResponseSchema(
  detailDataSchema,
) as z.ZodSchema<IAPI<IGetSocialPostDetailV1Data>>;

export type IGetSocialPostDetailV1Response = IAPI<IGetSocialPostDetailV1Data>;
